import {useHistory} from "react-router-dom";
import {useSelector} from "react-redux";
import {Routes} from "../../../routes";
import React from "react";
import CostosFijosMensual from "../../components/CostosFijos/CostosFijosMensual";
import CostoSemifijo from "../../components/CostosFijos/CostoSemifijo";
import CostoVenta from "../../components/CostosFijos/CostoVenta";
import CostoTotal from "../../components/CostosFijos/CostoTotal";

function CostosVentasPage() {
    const navigate = useHistory();
    const ciemId = useSelector(state => state.ciem.ciemId);
    if(!ciemId){
        alert("Para ingresar a esta opcion debe seleccionar una idea de negocio");
        //console.log("no tiene ciem")
        navigate.push(Routes.ListCiemPage.path);
    }
    return (
        <div>
            <CostoTotal ciemId={ciemId}/>
        </div>
    );
}

export default CostosVentasPage;